import { render, staticRenderFns } from "./StatOptions.vue?vue&type=template&id=374aa7b5&scoped=true"
import script from "./StatOptions.vue?vue&type=script&lang=js"
export * from "./StatOptions.vue?vue&type=script&lang=js"
import style0 from "./StatOptions.vue?vue&type=style&index=0&id=374aa7b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374aa7b5",
  null
  
)

export default component.exports